<template>
  <CustomHeader class="min-h-screen">
    <template #header>
      <div class="h-full w-full flex justify-center items-center text-lg font-bold">
        {{ selectedStoreType?.name }}
      </div>
    </template>
    <template #body>
      <div>
        <div class="h-8"></div>
        <MevcutTab :length-tab="2" @tab-change="resetCategoryId">
          <template #title>
            <div class="h-3"></div>
            <div v-if="!isMobileOrTablet" class="flex justify-center text-secondary items-center text-lg font-bold h-12">
              {{ selectedStoreType?.name }}
            </div>
          </template>
          <template #trigger-tab-1="{ activeIndex, activeTab }">
            <div @click="activeTab(1)">
              <div :class="{ 'style-trigger-tab': activeIndex === 1 }">
                {{ t('materials') }}
              </div>
            </div>
          </template>
          <template #trigger-tab-2="{ activeIndex, activeTab }">
            <div @click="activeTab(2)">
              <div :class="{ 'style-trigger-tab': activeIndex === 2 }">
                {{ t('stores') }}
              </div>
            </div>
          </template>

          <template #content-trigger-tab-2>
            <div class="border-b border-text_color mx-auto mb-3 max-w-md">
              <RikazSearchField
                :value="storeName"
                class="ltr:mr-3.5 rtl:ml-3.5"
                :placeholder="t('enter_search_text')"
                :input-class="'w-full '"
                :search-size-icon="20"
                prefix
                close-class="text-mevcut-light w-5 h-5 cursor-pointer"
                @search-term="filterStoreName"
              />
            </div>
            <div class="h-1"></div>
          </template>
          <template #tab-1="{ activeIndex }">
            <div class="w-full mx-auto">
              <MaterialsCatogriesWithSupportFilter
                :support-filter="true"
                style-filter="w-full"
                :store-type-id="selectedStoreType?.id"
                :categories="categories || undefined"
                :fetch-params="{}"
              >
                <template #Categories="{ categories: categoriesProps }">
                  <StoreTypesCategoryList :categories="categoriesProps" />
                </template>
              </MaterialsCatogriesWithSupportFilter>
              <MaterialsGrid
                v-if="activeIndex === 1"
                :items-per-page="20"
                with-query-params
                :fetch-params="{ store_type_id: route.query.store_type_id }"
                class="mb-5"
                manual
              />
            </div>
          </template>
          <template #tab-2="{ activeIndex }">
            <div class="h-8"></div>
            <StoresGrid
              v-if="activeIndex == 2"
              :key="keyStoresGrid"
              class="mevcut-container mb-5"
              :fetch-params="{
                orderBy: 'id',
                name: storeName,
                store_type_id: route.query.store_type_id
              }"
              :with-query-params="false"
            />
          </template>
        </MevcutTab>
      </div>
    </template>
  </CustomHeader>
</template>

<script setup lang="ts">
const { url } = useDomainHost()
const { t } = useI18n()
const { storeTypes } = useStoreTypes()
const { isMobileOrTablet } = useDevice()
const keyStoresGrid = ref<number>(Math.random())
const route = useRoute()
const categories = ref<Category[] | null>(null)
const selectedStoreType = computed(() =>
  storeTypes.value?.find(
    (el) => el.id.toString() === route.query.store_type_id?.toString()
  )
)
const storeName = ref(route.query.storeName as string)
getCategories()
watch(
  () => route.query.store_type_id,
  () => {
    getCategories()
    keyStoresGrid.value = Math.random()
  }
)
function filterStoreName(value: string) {
  if (value.trim() !== storeName.value) {
    storeName.value = value.trim()
    useQueryNavigation({ storeName: value.trim() })
    keyStoresGrid.value = Math.random()
  }
}

function resetCategoryId() {
  useQueryNavigation({ category_id: undefined })
}
function getCategories() {
  categories.value = selectedStoreType?.value?.parent_categories ?? []
}
useServerSeoMeta(
  useOgMeta(
    url + '/store-type',
    t('store_types'),
    t('mevcut_description'),
    url + '/images/mevcut.webp'
  )
)
useHead({
  title: t('store_types'),
  link: [useSeoCanonical(url + '/store-type')],
  script: [
    useSeoBreadcrumb([
      useSeoBreadcrumbItem(1, t('home'), url),
      useSeoBreadcrumbItem(2, t('store_types'), url + '/store-type')
    ])
  ]
})
</script>
<style>
.style-trigger-tab {
  @apply font-bold text-green-800 border-b-4 pb-2 border-green-800 w-max mx-auto;
}
</style>
